import React, {useState} from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {login} from '../../../api/POCCMSPortalAPI/login/loginCalls';
import {useAppDispatch} from '../../../store/hooks';
import {useNavigate} from 'react-router-dom';
// import {useSelector} from 'react-redux';

const theme = createTheme();

export default function LoginPage() {
  const navigate = useNavigate();
  const [isLoginValid, setIsLoginValid] = useState(true);
  const dispatch = useAppDispatch();
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    login(data.get('email').toString(), data.get('password').toString())
      .then(data => {
        if (!data.token) {
          setIsLoginValid(false);
          return;
        }
        setIsLoginValid(true);
        dispatch({type: 'SET_JWT', JWT: data});
        return navigate('/POCtoolsCMSHome');
      })
      .catch(error => {
        console.error('Error:', error);
        setIsLoginValid(false);
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{mt: 1}}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            {!isLoginValid && (
              <Typography variant="body2" color="error" align="center">
                Invalid login. Please check your email and password.
              </Typography>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{mt: 3, mb: 2}}>
              Sign In
            </Button>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
